/*
 * @Author: hadlinks
 * @Date: 2022-05-12 17:42:27
 * @LastEditors: xiaoqi 1040276698@qq.com
 * @LastEditTime: 2022-06-01 17:25:02
 * @Description: 配置 状态+文字 形式的参数
 * @Example: 
export const enbaleDisableStatus = {
  enable: {
    iconClass: 'icon-enable1',
    color: blueColor
  },
  disbale: {
    iconClass: 'icon-stop_use',
    color: redColor
  }
}
 * enbaleDisableStatus 中的键（enable | disbale），表示状态字段对应的值。
 * {
    iconClass: 'icon-enable1', // iconfont上对应的icon类名
    color: blueColor // icon 对应的颜色
   } 
   是 状态组件（@/components/CommonTable/Status.vue）需要的参数。
   

 */

// 导入要使用的 scss颜色变量
import {
  blueColor,
  grayColor,
  redColor,
  yellowColor,
  cyanblueColor,
  purpleColor
} from '@/style/var.scss'
import i18n from '@/locales/index'
/*
    在/离线
    gsm_online: 2G/3G/4G/5G 在线
    online: wifi 在线
    offline: 离线
*/
export const onOffLineStatus = {
  gsm_online: {
    iconClass: 'icon-online_WiFi1',
    color: blueColor
  },
  online: {
    iconClass: 'icon-online_WiFi1',
    color: blueColor
  },
  offline: {
    iconClass: 'icon-offline_WiFi1',
    color: grayColor
  }
}

/*
    设备状态
    normal: 正常
    alarm: 告警
    fault: 故障
*/
// export const deviceStatus = {
//   normal: {
//     color: cyanblueColor
//   },
//   alarm: {
//     color: yellowColor
//   },
//   fault: {
//     color: redColor
//   }
// }

// //烹饪中
// cooking,
//   //清洗中
//   washing,
//   //快速冷却中
//   rapidCooling,
//   //分层计时
//   stratifiedTiming,
//   //故障
//   fault,
//   //待机
//   standby,

export const deviceStatus = {
  cooking: {
    color: yellowColor
  },
  cooling: {
    color: blueColor
  },
  washing: {
    color: cyanblueColor
  },
  await: {
    color: grayColor
  },
  error: {
    color: redColor
  },
  layerTiming: {
    color: purpleColor
  },
  normal: {
    color: cyanblueColor
  }
}

/*
    启用/禁用状态
    enable: 启用
    disbale: 禁用
*/
export const enbaleDisableStatus = Object.freeze({
  ENABLE: {
    iconClass: 'icon-enable1',
    color: blueColor
  },
  DISABLED: {
    iconClass: 'icon-stop_use1',
    color: redColor
  }
})

/*
    任务状态
    ENABLE: 启用
    DISABLE: 禁用
    EXAMINE_WAIT: 待审批
    EXAMINE_REJECT: 审批撤回
*/
export const taskStatus = {
  EXAMINE_WAIT: {
    iconClass: 'icon-approval_pending1',
    color: yellowColor
  },
  EXAMINE_REJECT: {
    iconClass: 'icon-fail1',
    color: redColor
  },
  ENABLE: {
    iconClass: 'icon-enable1',
    color: blueColor
  },
  DISABLE: {
    iconClass: 'icon-stop_use1',
    color: redColor
  }
}

/*
    升级结果状态
    SUCCESS: 成功
    AWAIT_UPGRADE: 未升级
    FAILURE: 失败
*/
export const upgradeResStatus = {
  SUCCESS: {
    iconClass: 'icon-success1',
    color: cyanblueColor
  },
  AWAIT_UPGRADE: {
    iconClass: 'icon-not_upgraded1',
    color: yellowColor
  },
  FAILURE: {
    iconClass: 'icon-fail1',
    color: redColor
  }
}

export const languageList = [
  {
    value: 'zh',
    label: i18n.t('Common.Chinese')
  },
  {
    value: 'en',
    label: i18n.t('Common.English')
  },
  {
    value: 'de',
    label: i18n.t('Common.German')
  },
  {
    value: 'es',
    label: i18n.t('Common.Spanish')
  },
  {
    value: 'it',
    label: i18n.t('Common.Italian')
  },
  {
    value: 'fr',
    label: i18n.t('Common.French')
  }
]

//公制单位
export const MeUnitList = [
  {
    value: 'g',
    label: 'g'
  },
  {
    value: 'kg',
    label: 'kg'
  },
  {
    value: 'mL',
    label: 'mL'
  },
  {
    value: 'L',
    label: 'L'
  },
  {
    value: 'cm',
    label: 'cm'
  }
]

//英制单位
export const EnUnitList = [
  {
    value: 'oz',
    label: 'oz'
  },
  {
    value: 'lb',
    label: 'lb'
  },
  {
    value: 'gal',
    label: 'gal'
  },
  {
    value: 'in',
    label: 'in'
  }
]

export const preModelList = [
  {
    value: 'THAW',
    label: i18n.t('RecipeManage.listThaw')
  },
  {
    value: 'STEAM',
    label: i18n.t('RecipeManage.listSteam')
  },
  {
    value: 'ROAST',
    label: i18n.t('RecipeManage.listBake')
  },
  {
    value: 'BARBECUE',
    label: i18n.t('RecipeManage.listBBC')
  },
  {
    value: 'FRY',
    label: i18n.t('RecipeManage.listFry')
  },
  {
    value: 'GRILL',
    label: i18n.t('RecipeManage.listGrill')
  },
  {
    value: 'STEW',
    label: i18n.t('RecipeManage.listStew')
  },
  {
    value: 'LOW_TEMPERATURE_COOKING',
    label: i18n.t('RecipeManage.listLowTCook')
  },
  {
    value: 'FERMENTATION',
    label: i18n.t('RecipeManage.listLowTCook')
  },
  {
    value: 'HEAT_PRESERVATION',
    label: i18n.t('RecipeManage.listKeepT')
  }
]

export const limitLine = [
  {
    value: 'Y',
    label: i18n.t('Device.isInExpirationDateY')
  },
  {
    value: 'N',
    label: i18n.t('Device.isInExpirationDateN')
  }
]

/*
    发布/未发布状态
    Y: 已发布
    N: 未发布
*/
export const PUBLISHStatus = Object.freeze({
  Y: {
    iconClass: 'icon-enable1',
    color: blueColor
  },
  N: {
    iconClass: 'icon-stop_use1',
    color: redColor
  }
})

// ascending 顺序上升， descending：倒序下降
export const sortMap = {
  ascending: 1,
  descending: -1
}

// 设备 当前 运行步骤类型 1预热，2时间控制，3中芯探针控制，4温差控制
export const DeviceCurrStepType = {
  1: i18n.t('Device.preHeat'),
  2: i18n.t('Device.timeModel'),
  3: i18n.t('Device.midModel'),
  4: i18n.t('Device.diffModel')
}

export const iceDeviceStatus = {
  0: i18n.t('Common.off'),
  1: i18n.t('Common.open')
}
